<template>
    <div class="midNightTarget-wrapper mx-auto"
        :style="rulesPopupVisible ? { overflow: 'hidden', height: '100vh' } : {}">
        <div class="tt-middleSec">
            <div class="position-relative rounded-15 overflow-hidden tt-topSec"
                :style="{ backgroundImage: `url(${require('@/assets/images/midNightTargetImages/small_top_bg.webp')})` }">
                <div class="d-flex justify-content-between align-items-start tt-top-boxes">
                    <div class="bg-white rounded-15 tt-top-leftBox">
                        <div class="tt-current-no-day">Day {{ currentDayNumber }}/<span class="total-days">{{
                            tt_monthData.last_day_of_month }}</span></div>
                        <div class="tt-Completed-no-days">Completed {{ tt_monthData.completed_days }}/{{
                            tt_monthData.max_day }}</div>
                    </div>
                    <div class="tt-top-rightBox">
                        <!-- <div class="bg-white rounded-15 tt-grade-typeBox">Grade {{ tt_monthData.grade }} - <span
                                class="text-capitalize">{{ tt_monthData.talent }}</span></div> -->
                        <div class="bg-white rounded-15 text-center tt-rewardBox"><span class="">Reward</span> : {{
                            tt_monthData.reward_beans }}</div>
                    </div>
                </div>
                <div class="tt-progressbar-sec" v-if="activeTab === 'thisMonth'">
                    <div class="tt-progressbar-secInner">
                        <div class="progress-hrs progress-min-hrs">0<sup>hr</sup></div>
                        <div class="position-relative tt-progress-box">
                            <div class="bg-white text-center mx-auto tt-spentTime">{{
                                formatTime(tt_monthData.per_day_complete_time) }}</div>
                            <div class="position-relative tt-progressbar">
                                <div class="tt-progressbar-fill" :style="{ width: tt_monthData.tt_progress + '%' }">
                                </div>
                            </div>
                            <div class="text-center tt-remainingTime" v-if="tt_monthData.per_day_remaining_time > 0">
                                Remaining {{ formatTime(tt_monthData.per_day_remaining_time) }}</div>
                        </div>
                        <div class="progress-hrs progress-max-hrs">{{ (tt_monthData.per_day_total_time || 0) / 3600
                            }}<sup>hr</sup></div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between tt-middle-heading">
                <h3 class="m-0">Monthly Calculator</h3>
                <div class="tt-rulesBtn" @click="showRulesPopup">Rules</div>
            </div>
            <div class="overflow-hidden rounded-15 tt-monthlyCalculator-sec"
                :style="{ backgroundImage: `url(${require('@/assets/images/midNightTargetImages/big_bottom_bg.webp')})` }">
                <div class="d-flex justify-content-center align-items-center tt-calculator-tabes">
                    <div class="tt-calculator-tab" :class="{ 'tt-active': activeTab === 'thisMonth' }"
                        @click="handleTabChange('thisMonth')">This Month</div>
                    <div class="tt-calculator-tab" :class="{ 'tt-active': activeTab === 'lastMonth' }"
                        @click="handleTabChange('lastMonth')">Last Month</div>
                </div>
                <div class="tt-calculator-dateWrapper">
                    <ul>
                        <li v-for="entry in parsedDailyData" :key="entry.day" :class="{
                            currentdate: activeTab === 'thisMonth' && entry.day === today && entry.seconds < (tt_monthData.per_day_total_time),
                            oldDate: (activeTab === 'lastMonth' && entry.seconds >= (tt_monthData.per_day_total_time)) || (entry.seconds >= (tt_monthData.per_day_total_time)),
                            tt_notComlete: entry.seconds < (tt_monthData.per_day_total_time || 0)
                        }">
                            <div class="d-flex justify-content-center align-items-center tt-date">{{ entry.day }}</div>
                            <div class="tt-timeBox">{{ formatToHHMM(entry.seconds) }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="tt-bottomSec">
            <div class="tt-impRule">
                <strong>Notice :</strong> If you do not stream dance for 3 hours a day for at least 24 days in the
                month, or if you take a break for 2 consecutive days, you will not be eligible for the monthly reward.
            </div>
        </div>
        <!-- Info Popup Start  -->
        <div class="mode-area" v-show="isPopupOverlayVisible"></div>
        <div id="rulesPopup"
            :class="{ 'popup_box tt_rules_popup': true, 'rule-pop-up': true, 'transform-in': rulesPopupVisible, 'transform-out': !rulesPopupVisible }">
            <div class="closePopup rulePopupCloseBtn">
                <img :src='popupGrayCloseIcon' @click="showRulesPopup" alt="" />
            </div>
            <div class="rulePopup-topHD">
                <div class="text-center rp-HD">Rules For Earning</div>
            </div>
            <div class="rule-content">
                <ul class="rule-listWrap">
                    <li>
                        <div>Host must go live daily between <b>8:00 PM - 4:00 AM (IST)</b>.</div>
                        <div>होस्ट को हर दिन रात <b>8:00 बजे से सुबह 4:00 बजे (IST)</b> के बीच लाइव आना अनिवार्य है।</div>
                    </li> 
                    <li>
                        <div>Minimum <b>3 hours live streaming</b> required per day.</div>
                        <div>हर दिन कम से कम <b>3 घंटे का लाइव स्ट्रीमिंग</b> करना आवश्यक है।</div>
                    </li>                    
                    <li>
                        <div>Host can take <b>5 days off per month</b> (with prior notice).</div>
                        <div>होस्ट को <b>हर महीने में 5 दिन की छुट्टी लेने की अनुमति है</b> (पहले से सूचित करना आवश्यक है)।</div>
                    </li> 
                    <li>
                        <div>Host must answer <b>all incoming call requests</b> during live sessions.</div>
                        <div>लाइव सत्र के दौरान होस्ट को <b>सभी इनकमिंग कॉल रिक्वेस्ट का जवाब देना अनिवार्य है।</b></div>
                    </li> 
                    <li>
                        <div><b>Monthly fixed salary:</b> $100 USD, released via standard payout method.</div>
                        <div><b>मासिक फिक्स वेतन:</b> $100 USD, जो स्टैण्डर्ड पेआउट विधि से दिया जाएगा।</div>
                    </li> 
                    <li>
                        <div>Any <b>coins earned</b> by the host are separate from the monthly salary, and the host can <b>withdraw their coin earnings anytime</b> as per the standard withdrawal policy.</div>
                        <div>होस्ट द्वारा <b>कमाए गए कॉइन्स</b> मासिक वेतन से अलग होंगे, और <b>होस्ट उन्हें कभी भी मानक निकासी नीति के अनुसार निकाल सकता है।</b></div>
                    </li> 
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import './MidnightTarget.css'
import smallTopBG from '../../assets/images/midNightTargetImages/small_top_bg.webp'
import bigBottomBG from '../../assets/images/midNightTargetImages/big_bottom_bg.webp'
import popupGrayCloseIcon from '../../assets/images/popupCloseIcon-gray.svg';
export default {
    name: 'MidnightTarget',
    data() {
        return {
            respData: [],
            tt_monthData: [],
            daysInMonth: [],
            // today: null,
            smallTopBG,
            bigBottomBG,
            activeTab: 'thisMonth',
            popupGrayCloseIcon,
            isPopupOverlayVisible: false,
            rulesPopupVisible: false,
        }
    },
    mounted() {
        this.userId = this.$route.params.user_id;
        this.fetchThisWeekData();
    },
    computed: {
        currentDayNumber() {
            const day = this.tt_monthData?.current_day;
            return day ? day.replace('day_', '') : '';
        },
        parsedDailyData() {
            const data = this.tt_monthData?.daily_data || {};
            return Object.keys(data).map(key => {
                const day = parseInt(key.replace('day_', ''));
                return {
                    day,
                    seconds: data[key]
                };
            }).sort((a, b) => a.day - b.day);
        },
        today() {
            return new Date().getDate();
        }
    },
    methods: {

        fetchThisWeekData() {

            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/freetarget-weekly`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })

                .then(response => {
                    this.respData = response.data.result;
                    this.handleTabChange('thisMonth');
                    this.calculateProgress();
                })
                .catch(error => {
                    console.error("Error Featching This Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        handleTabChange(tab) {
            this.activeTab = tab;
            if (tab === 'thisMonth') {
                this.tt_monthData = this.respData.currentMonthData || {};
            } else if (tab === 'lastMonth') {
                this.tt_monthData = this.respData.lastMonthData || {};
            }
            this.calculateProgress();
        },

        calculateProgress() {
            if (this.tt_monthData.per_day_total_time === 0) {
                this.tt_monthData.tt_progress = 0;
            } else {
                this.tt_monthData.tt_progress =
                    (this.tt_monthData.per_day_complete_time * 100) /
                    this.tt_monthData.per_day_total_time;
            }
        },

        formatTime(seconds) {
            seconds = seconds || 0;
            const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
            const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
            const secs = String(seconds % 60).padStart(2, '0');
            return `${hrs}:${mins}:${secs}`;
        },

        formatToHHMM(seconds) {
            seconds = seconds || 0;
            const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
            const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
            return `${hrs}:${mins}`;
        },

        showRulesPopup() {
            this.rulesPopupVisible = !this.rulesPopupVisible;
            this.isPopupOverlayVisible = !this.isPopupOverlayVisible;
        },        
    },
}
</script>